/**
 * 意见反馈
 */
import { FEEDBACK } from '../types';

export default {
    name: `${FEEDBACK}`,
    path: '/feedback',
    component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/'),
    redirect: { name: `${FEEDBACK}Index` },
    meta: {
        title: '意见反馈',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${FEEDBACK}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${FEEDBACK}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/detail/Detail.vue'),
        // },
    ],
};
